export default __webpack_public_path__ + "static/nerd-darts-c5ad66423d1660f01e53761d8ac4f39b.jpg";